import PropTypes from 'prop-types';
import { usePrevious } from '@Pages/RetroSynthesis/ProjectRoute/hooks';
import { useEffect, useRef } from 'react';

/*
 * 1st render: conditionsIsShown = undefined, activeStep = null
 * - if conditions panel is shown by default:
 *     2nd render: conditionsIsShown = true, activeStep = null
 *     3rd render: conditionsIsShown = true, activeStep = someStep
 * - if conditions panel is hidden by default:
 *     2nd render: conditionsIsShown = false, activeStep = null
 *     - if user clicks on a link node:
 *       3rd render: conditionsIsShown = true, activeStep = someStep
 *     - if user clicks on Show Conditions button:
 *       3rd render: conditionsIsShown = true, activeStep = null
 *       4th render: conditionsIsShown = true, activeStep = someStep
 */
function TrackPageLoadAndStepAutoSet({ activeStep, conditionsIsShown, onPageLoad, onStepAutoSetWithDelay }) {
  const prevActiveStep = usePrevious(activeStep);
  const prevConditionsIsShown = usePrevious(conditionsIsShown);

  const shownByDefault = useRef();
  const pageLoaded = useRef(false);
  const stepAutoSet = useRef(false);

  useEffect(() => {
    if (shownByDefault.current == null && prevConditionsIsShown == null && conditionsIsShown != null) {
      shownByDefault.current = conditionsIsShown;
      if (!shownByDefault.current) {
        onPageLoad();
        pageLoaded.current = true;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevConditionsIsShown, conditionsIsShown]);

  useEffect(() => {
    if (shownByDefault.current && !pageLoaded.current && !prevActiveStep && !!activeStep) {
      onPageLoad(activeStep);
      pageLoaded.current = true;
      stepAutoSet.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevActiveStep, activeStep]);

  useEffect(() => {
    if (
      !shownByDefault.current &&
      pageLoaded.current &&
      !stepAutoSet.current &&
      conditionsIsShown &&
      prevConditionsIsShown &&
      !prevActiveStep &&
      !!activeStep
    ) {
      onStepAutoSetWithDelay(activeStep);
      stepAutoSet.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevActiveStep, activeStep, prevConditionsIsShown, conditionsIsShown]);

  return null;
}

TrackPageLoadAndStepAutoSet.defaultProps = {
  onPageLoad: () => null,
  onStepAutoSetWithDelay: () => null,
};

TrackPageLoadAndStepAutoSet.propTypes = {
  activeStep: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  conditionsIsShown: PropTypes.bool,
  onPageLoad: PropTypes.func,
  onStepAutoSetWithDelay: PropTypes.func,
};

export default TrackPageLoadAndStepAutoSet;
